<!--Footer Starts-->
<footer class="footer">
  <p class="copyright clearfix text-muted m-0">
    Copyright &copy; {{currentDate | date: 'yyyy'}} LigaSoft.
    <span class="d-none d-sm-inline-block">All rights reserved.</span>
  </p>
</footer>
<!--Footer Ends-->
